/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import getConfig from 'next/config';
import Icon from 'base-ui/dist/Icon';
import Button from 'base-ui/dist/Button';
import InputField from 'base-ui/dist/InputField';
import { FormattedMessage } from 'react-intl';
import { intl } from 'components/LocaleProvider';
import NavLink from 'components/NavLink';
import messages from './messages';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const SignUpForm = ({ onSubmit }) => {
  const { register, handleSubmit, errors } = useForm();
  const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className="field-with-icon">
        <Icon prefix="far" name="user-circle" className="big icon regent-grey-color" style={{ fontSize: '2rem' }}></Icon>
        <InputField
          name="displayName"
          type="text"
          placeholder={intl.formatMessage(messages.labelFullName)}
          className="input full big"
          maxLength="30"
          ref={register({ required: true, validate: (value) => value.split(' ').length >= 2 && value.split(' ')[1] !== '' })}
          meta={{ touched: errors.displayName, error: (errors.displayName?.type === 'required' && intl.formatMessage(messages.requiredField)) || (errors.displayName?.type === 'validate' && intl.formatMessage(messages.invalidField)) }}
        />
      </div>
      <div className="field-with-icon">
        <Icon prefix="far" name="envelope" className="big icon regent-grey-color" style={{ fontSize: '2.125rem' }}></Icon>
        <InputField
          name="email"
          type="email"
          placeholder={intl.formatMessage(messages.labelEmail)}
          className="input full big"
          ref={register({ pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, required: true })}
          meta={{ touched: errors.email, error: (errors.email?.type === 'required' && intl.formatMessage(messages.requiredField)) || (errors.email?.type === 'pattern' && intl.formatMessage(messages.invalidField)) }}
        />
      </div>
      <div className="field-with-icon">
        <Icon prefix="fas" name="asterisk" className="big icon regent-grey-color" style={{ fontSize: '2rem' }}></Icon>
        <InputField
          name="password"
          type="password"
          placeholder={intl.formatMessage(messages.labelPassword)}
          className="input full big"
          ref={register({ required: true })}
          meta={{ touched: errors.password, error: intl.formatMessage(messages.requiredField) }}
        />
      </div>
      <div style={{ marginTop: '10px', marginBottom: '10px' }}>
        <input
          id="acceptTermsAndConditions"
          type="checkbox"
          name="acceptTermsAndConditions"
          checked={acceptTermsAndConditions}
          onChange={(event) => setAcceptTermsAndConditions(event.target.checked)}
          ref={register({ required: true })}
        />
        <label htmlFor="acceptTermsAndConditions">
          <FormattedMessage
            {...messages.checkboxLabelAgree}
            values={{
              link1: (
                <NavLink
                  href={publicRuntimeConfig.terms_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="highlight grey-border"
                >
                  <FormattedMessage {...messages.checkboxLabelTermsAndConditionsCheckbox} />
                </NavLink>
              ),
              link2: (
                <NavLink
                  href={publicRuntimeConfig.privacy_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="highlight grey-border"
                >
                  <FormattedMessage {...messages.checkboxLabelConsentTerms} />
                </NavLink>
              )
            }}
          />
        </label>
        {errors.acceptTermsAndConditions && <span className="field-error">{intl.formatMessage(messages.requiredField)}</span>}
      </div>
      <Button tag="button" type="submit" className="full big white-bg main-border main-color">
        <FormattedMessage {...messages.labelSignUpMContigo} />
      </Button>
    </form>
  );
};

SignUpForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired
};

export default SignUpForm;
